import { eventBus } from '@/main.js'
export default {
  watch: {
    showBettingHistory: function (showBettingHistory) {
      if (showBettingHistory) {
        this.mainPageScrollYPosition = window.pageYOffset
        window.scrollTo(0, 0)
        if (this.isMobileDevice()) {
          eventBus.onGameScrollLock('true')
        }
      } else {
        window.scrollTo(0, this.mainPageScrollYPosition)
        window.dispatchEvent(new Event('resize'))
        if (this.isMobileDevice()) {
          eventBus.onGameScrollUnock('true')
        }
      }
    }
  }
}
